import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from 'src/shared/util/util';
import { Component, ElementRef, ChangeDetectorRef, ViewChild, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

import { Auth } from 'src/providers/auth/auth';
import { Card } from 'src/providers/card/card';
import { Client } from 'src/providers/client/client';
import { ClientHub } from 'src/providers/client-hub/client-hub';
import { Invoices } from 'src/providers/invoices/invoices';
import { PaymentMethodsProvider } from 'src/providers/payment-methods/payment-methods.provider';
import { Loading } from 'src/shared/components/loading/loading';
import { Me } from 'src/providers/me/me';
import { Pros } from 'src/providers/pros/pros';
import { StripeProvider } from 'src/providers/stripe/stripe-provider';
import { Schedule } from 'src/providers/schedule/schedule';
import { WindowService } from 'src/shared/providers/window.service';

import { validateEmail } from 'src/shared/validator/validateEmail';

import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { SuccessPage } from 'src/shared/pages/success/success';

import { TidyCurrencyPipe } from 'src/shared/pipes/tidy-currency.pipe';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { ThemeService } from 'src/shared/services/theme.service';
import { getSellerDisplay, isVendorInvoice } from 'src/shared/util/get-seller-display';

@Component({
    templateUrl: 'pending-invoice.html',
    standalone: false
})

export class PendingInvoicePage implements OnDestroy, OnInit, AfterViewInit {

  amountCreditUsed: number;
  allowsCreditCard: boolean;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  clientHubInfo: any;
  cardEl: any = null;
  isDestroyed = false;
  mountRequestId = 0;
  cardHandler = this.onChange.bind(this);
  clientEmail: string;
  clientName: string;
  copied: boolean;
  creditWithPro: number;
  creditWithTIDY: number;
  companyName: string | null;
  errorMessage: string;
  form: UntypedFormGroup;
  fromStartDuration: string;
  hasAccount: boolean;
  howToPayItems: any;
  isInternalComment: boolean;
  isAuthenticated: boolean;
  isLoggedIntoClientApp: boolean;
  lastFourCC: string;
  loaded: boolean;
  invoice: any;
  invoiceNotes: any;
  messageSelectItems: any;
  otherOptionItems: any;
  proReportedDuration: string;
  proEmail: string;
  proPhone: string;
  proId: number;
  paymentOptions: any;
  prefersCreditCard: boolean;
  proName: string;
  selectedCredits: any[] = [];
  selectedMessageType: any;
  selectedOtherOption: any;
  saveCardForFuture = true;
  submitted: boolean;
  showAllInvoiceNotes: boolean;
  totalOwed: number;
  termsError: boolean;
  hasValidCaptcha: string | null = null;
  captchaErrorMessage: boolean;
  dialogParams: any;
  isRightSideContent: boolean;
  customBack: string;
  howToPayLabel: string;
  showPaymentMethodOptions = true;
  showACHDebitMessage: boolean;
  showTooMuchCreditSelectedWarning: boolean;
  showNotEnoughCreditWarning: boolean;
  initiallySelectedCredits: any = {};
  paymentPreview: any;
  newCard: any;
  isVendorInvoice: boolean;
  checkPaymentMethods: any[] = [];
  noCompatibleMethods: boolean;


  boundSendMessage = this.sendMessage.bind(this);
  boundSendAttachment = this.sendAttachment.bind(this);
  boundPayInvoice = this.payInvoice.bind(this);

constructor(
    private auth: Auth,
    private card: Card,
    private cd: ChangeDetectorRef,
    private client: Client,
    private clientHub: ClientHub,
    private fb: UntypedFormBuilder,
    private invoices: Invoices,
    private me: Me,
    private navCtrl: CustomNavController,
    private pros: Pros,
    private route: ActivatedRoute,
    private stripeProvider: StripeProvider,
    private schedule: Schedule,
    private util: Util,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
    private themeService: ThemeService,
    private paymentMethodsProvider: PaymentMethodsProvider,
    public windowService: WindowService
  ) {
    this.form = this.fb.group({
      howToPay: ['', Validators.required],
      firstName: '',
      lastName: '',
      email: [''],
      password: [''],
      terms: [true],
      otherOptions: [''],
      message: [''],
      messageType: ['public_reply'],
      amountOfTidyCreditToUse: ['']
    });
    this.form.controls.howToPay.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.mountStripeForm();
    });
  }

  async ngOnInit() {
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      if (this.isRightSideContent) {
        this.dialogParams = await this.storage.retrieve('dialog-params');
        this.rightSidePanelService.setDialogPageTitle('Bill');
      }
      this.clientHubInfo = this.navCtrl.getParam('clientHubInfo');
      this.isLoggedIntoClientApp = !this.clientHubInfo;
      if (!this.clientHubInfo && this.windowService.isDesktopRes && !this.isRightSideContent) {
        await this.storage.save('shouldOpenBillPageID', parseInt(this.route.snapshot.paramMap.get('invoice_id')))
        return this.navCtrl.navigateForward('bills');
      }
      /* this.invoice = this.dialogParams?.invoice || this.navCtrl.getParam('invoice'); */
      if (!this.invoice) {
        const invoiceId = this.dialogParams?.invoiceId || parseInt(this.route.snapshot.paramMap.get('invoice_id'));
        const invoiceUUID = this.route.snapshot.paramMap.get('uuid');
        this.invoice = invoiceId ? await this.invoices.getInvoiceById(invoiceId) : await this.invoices.getInvoice(invoiceUUID);
      }
      const [isAuthenticated, clientName, lastFourCC, paymentOptions, invoiceNotes, job] = await Promise.all([
        this.checkIfIsAuthenticated(),
        this.getClientName(),
        this.getLastFourCC(),
        this.invoices.getPaymentOptions(this.invoice.uuid),
        this.getInvoiceNotes(),
        this.getJob()
      ]);
      this.isAuthenticated = isAuthenticated;
      this.clientName = clientName;
      this.lastFourCC = lastFourCC;
      this.paymentOptions = paymentOptions;
      this.invoiceNotes = invoiceNotes;
      this.customBack = await this.getParam('customBack');
      this.clientEmail = this.clientHubInfo?.client_hub_details.customer.email;
      this.companyName = localStorage.getItem('companyName');
      const sellerDisplay = getSellerDisplay(this.invoice);
      this.proEmail = this.invoice?.team?.owner?.email || await this.getParam('proEmail') || sellerDisplay.email;
      this.proPhone = this.invoice?.team?.owner?.phone || await this.getParam('proPhone') || sellerDisplay.phone;
      this.proId = await this.getParam('proId');
      this.hasAccount = this.clientHubInfo?.client_hub_details.customer.state === 'active' || await this.getParam('hasAccount');
      this.proName = this.invoice?.team?.owner?.name || await this.getParam('proName') || sellerDisplay.name;
      this.isVendorInvoice = isVendorInvoice(this.invoice);
      if (this.isVendorInvoice) {
        const allMethods = await this.paymentMethodsProvider.getPaymentMethods();
        this.checkPaymentMethods = (allMethods || []).filter((pm: any) => pm.type === 'check' && pm.status !== 'failed');
        this.noCompatibleMethods = this.checkPaymentMethods.length === 0;
      }
      this.form.patchValue({email: this.clientEmail});
      this.otherOptionItems = this.buildOtherOptionItems();
      this.creditWithPro = this.invoice.amount - this.invoice.amount_due;
      this.totalOwed = Math.max(0, this.invoice.amount - this.creditWithPro );
      if (this.isLoggedIntoClientApp) {
        this.proReportedDuration = this.pros.parseDurationIntoHoursAndMintes(job.homekeeper_jobs[0].job_durations.reported_by_homekeeper, 'proReportedDuration');
        this.fromStartDuration = this.pros.parseDurationIntoHoursAndMintes(job.homekeeper_jobs[0].job_durations.from_start_to_end_moment, 'fromStartDuration');
      }
      this.messageSelectItems = this.getMessageSelectItems();
      if (this.invoice.credits_to_use.length > 0) {
        this.howToPayLabel = `${new TranslationPipe().transform('How do you want to pay the ')} ${new TidyCurrencyPipe().transform(this.totalOwed)} ${new TranslationPipe().transform('balance?')}`;
        this.selectPossibleCreditsToUse();
        await this.checkHowMuchCreditIsUsed();
      }
      this.howToPayItems = await this.getHowToPayItems();
      this.patchHowToPayItem();
      this.form.patchValue({otherOptions: this.otherOptionItems[0].value});
      await this.getPaymentPreview();
      this.loaded = true;
    } catch (_err) {
      if (this.clientHubInfo) {return this.clientHub.goToErrorPage();}
      this.errorMessage = (_err.error && _err.error.message) ? _err.error.message : _err.message;
      this.util.showError(`${new TranslationPipe().transform('Error fetching invoice, please log in to view the bill if not logged in.')} ${this.errorMessage}`);
    }
  }

  patchHowToPayItem() {
    const hasCurrentCard = this.howToPayItems.some(item => item.value === 'currentCard');
    if (this.showPaymentMethodOptions) {
      this.form.patchValue({
        howToPay: hasCurrentCard ? 'currentCard' : 'newCard'
      });
    }
  }

  selectPossibleCreditsToUse() {
    if (!this.invoice?.credits_to_use || this.invoice.credits_to_use.length === 0) {
      return;
    }
    this.invoice.credits_to_use.forEach(credit => {
      const checkboxControlName = `${credit.title}_checkbox`;
      if (!this.form.contains(checkboxControlName)) {
        this.form.addControl(checkboxControlName, new UntypedFormControl(false));
      }
    });
    let remainingOwed = this.totalOwed;
    this.initiallySelectedCredits = {};
    for (const credit of this.invoice.credits_to_use) {
      if (remainingOwed > 0) {
        const checkboxControlName = `${credit.title}_checkbox`;
        this.form.patchValue({ [checkboxControlName]: true });
        this.initiallySelectedCredits[credit.title] = true;
        this.selectCredit(credit);
        let amountToUse;
        if (remainingOwed >= credit.available_amount) {
          amountToUse = credit.available_amount;
        } else {
          amountToUse = remainingOwed;
        }
        const amountInDollars = amountToUse / 100;
        this.form.patchValue({
          [credit.title]: amountInDollars.toFixed(2)
        });
        this.listenToCreditChanges(credit);
        remainingOwed -= amountToUse;
        if (remainingOwed <= 0) {
          break;
        }
      }
    }
  }

  async selectCredit(credit) {
    if (this.selectedCredits.includes(credit)) {
      this.form.removeControl(credit.title);
      this.selectedCredits = this.selectedCredits.filter((c) => c !== credit);
    } else {
      const creditControl = new UntypedFormControl('', [Validators.required]);
      this.form.addControl(credit.title, creditControl);
      this.selectedCredits.push(credit);
    }
    this.checkHowMuchCreditIsUsed();
    this.updateHowToPayLabel();
  }

  checkUncheckCredit(credit) {
    this.selectCredit(credit);
    if (this.selectedCredits.includes(credit)) {
      this.listenToCreditChanges(credit);
    }
    this.getPaymentPreview();
  }

  listenToCreditChanges(credit) {
    const creditControl = this.form.get(credit.title);
    if (creditControl) {
      creditControl.valueChanges.pipe(
        skip(1), // Skip the first emission (initial patch)
        debounceTime(500)
      ).subscribe(async () => {
        this.checkHowMuchCreditIsUsed();
        if (this.form.value.howToPay !== 'newCard') {
          this.getPaymentPreview();
        }
      });
    }
  }

  async getJob() {
    if (this.isLoggedIntoClientApp) {
      const job = this.navCtrl.getParam('job') || await this.schedule.getJobDetail(this.invoice.items[0].item_id);
      return job;
    } else {
      return null;
    }
  }

  async getInvoiceNotes() {
    if (this.isLoggedIntoClientApp) {
      return await this.invoices.getInvoiceNotes(this.invoice.id);
    }
    return [];
  }

  async getClientName() {
    if (this.invoice?.customer?.name) {
      return this.invoice?.customer?.name;
    } else {
      const settings = await this.client.getClientSettings();
      return settings.profile.first_name;
    }
  }

  async getLastFourCC(): Promise<any> {
    if (this.isLoggedIntoClientApp) {
      const cards = await this.card.getCreditCards();
      let lastFourCC = null;
      cards.map((card) => {
        if (this.invoicedAddressIsInClientsTeam(card)) {
          lastFourCC = card.metadata.last4;
        }
      });
      if (!lastFourCC) {
        cards.map((card) => {
          if (card.is_primary) {
            lastFourCC = card.metadata.last4;
          }
        });
      }
      return lastFourCC;
    } else {
      return null
    }
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName)
    }
    return param;
  }

  invoicedAddressIsInClientsTeam(card) {
    let addressIsInTeam = false;
    card.account_teams.map((team) => {
      team.address_ids.map((id) => {
        if (id === this.invoice.items[0].service_details.address.id) {
          addressIsInTeam = true;
        }
      });
    });
    return addressIsInTeam;
  }

  buildOtherOptionItems() {
    const array = [];
    this.paymentOptions.map((option) => {
      const name = option.team_payment_option_type.name;
      if (option.team_payment_option_type.state === 'active') {
        if (name === 'Card') {
          this.allowsCreditCard = true;
          this.prefersCreditCard = option.is_preferred;
        } else {
          array.push({
            viewValue: option.is_preferred ? name + new TranslationPipe().transform(' (preferred)') : name,
            value: option.team_payment_option_type.id
          });
        }
      }
    });
    array.push({
      viewValue: new TranslationPipe().transform('ACH Debit'),
      value: 'achDebit'
    })
    return array;
  }

  async checkIfIsAuthenticated() {
    if (!this.clientHubInfo) {
      return true;
    }
    if (!this.auth.isAuthenticated()) {
      return false;
    }
    const client = await this.me.load();
    const isSameAccountAsInvoice = client.customer_account.email === this.clientEmail;
    return isSameAccountAsInvoice;
  }

  ngAfterViewInit() {
    // Mount Stripe form after view is initialized if 'newCard' is selected
    if (this.loaded && this.form.value.howToPay === 'newCard') {
      setTimeout(() => this.mountStripeForm(), 0);
    }
  }

  async mountStripeForm() {
    const requestId = ++this.mountRequestId;
    if (this.form.value.howToPay !== 'newCard') {
      if (this.cardEl) {
        this.stripeProvider.destroyCard();
        this.cardEl = null;
      }
      return;
    }
    await this.stripeProvider.ensureLoaded();
    // StripeProvider is app-wide, so a card created after this page is gone (or superseded) would never be destroyed and would block every other card form
    if (this.isDestroyed || requestId !== this.mountRequestId || this.form.value.howToPay !== 'newCard') {
      return;
    }
    this.cardEl = this.stripeProvider.getCardElement(!this.themeService.isDarkMode());
    if (this.cardEl && this.cardInfo) {
      this.cardEl.mount(this.cardInfo.nativeElement);
      this.cardEl.addEventListener('change', this.cardHandler);
    }
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    if(this.cardEl && this.cardInfo){
      this.cardEl.unmount(this.cardInfo.nativeElement);
      this.cardEl.removeEventListener('change', this.cardHandler);
    }
    this.stripeProvider.destroyCard();
  }

  onChange(err: any) {
    this.errorMessage = err.error ? err.error.message : err.message;
    this.cd.detectChanges();
  }

  async getHowToPayItems() {
    if (this.isVendorInvoice) {
      return this.checkPaymentMethods.map((pm: any) => ({
        viewValue: `${new TranslationPipe().transform('Pay by check from')} ${pm.metadata?.bank_name || 'bank account'}`,
        value: `check_${pm.id}`,
      }));
    }
    const options = [];
    if (this.allowsCreditCard) {
      if (this.hasAccount && this.lastFourCC) {
        options.push({
          viewValue: this.prefersCreditCard ? `${new TranslationPipe().transform('Use my primary credit card on file (ends in')} ${this.lastFourCC}) ${new TranslationPipe().transform('(preferred)')}` : `${new TranslationPipe().transform('Use my primary credit card on file (ends in')} ${this.lastFourCC})`,
          value: 'currentCard'
        });
      }
      options.push({
        viewValue: this.prefersCreditCard && !(this.hasAccount && this.lastFourCC) ? 'Use new card (preferred)' : 'Use new card',
        value: 'newCard'
      });
    }
    if (this.otherOptionItems.length > 0) {
      options.push({
        viewValue: 'Other options',
        value: 'alreadyPaid'
      });
    }
    return options;
  }

  captchaEvents(captchaResult){
    this.hasValidCaptcha = captchaResult;
  }

  goToAddCheckPaymentMethod() {
    this.navCtrl.navigateForward('payment-method-form');
  }

  async payInvoice() {
    this.submitted = true;
    this.termsError = false;
    this.storage.save('didMakeBillChanges', true);
    this.setFormValidation();
    if (!this.form.valid) {
      if (this.form.value.howToPay === '') {
        this.errorMessage = 'Please select a payment method.';
      }
      if (!this.form.controls.terms.valid) {
        this.termsError = true;
      }
      return;
    }
    try {
      switch (this.form.value.howToPay) {
        case 'alreadyPaid':
          this.form.controls.otherOptions.setValidators(Validators.required);
          this.form.controls.otherOptions.updateValueAndValidity();
          if (!this.form.valid) {
            return;
          }
          const directPaymentPayload = this.getDirectPaymentPayload();
          await this.invoices.recordDirectPayment(directPaymentPayload);
          break;
        default:
          const payInvoicePayload = this.getInvoicePayload();
          await this.invoices.payInvoiceCardOnFile(this.invoice.id, payInvoicePayload);
          break;
      }
      this.goToSuccessPage();
    } catch(err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  setFormValidation() {
    if (this.showPaymentMethodOptions) {
      this.form.controls.howToPay.setValidators(Validators.required);
      this.form.controls.howToPay.updateValueAndValidity();
    } else {
      this.form.controls.howToPay.clearValidators();
      this.form.controls.howToPay.updateValueAndValidity();
    }
  }

  getDirectPaymentPayload() {
    return {
      invoice_uuid: this.invoice.uuid,
      payment_type_id: this.form.value.otherOptions,
      amount: this.invoice.amount_due,
      invoice_id: this.invoice.id
    }
  }

  getNewCardPayload(cardData) {
    return {
      card_token: cardData.card_token,
      invoice_uuid: this.invoice.uuid
    };
  }

  async goToSuccessPage() {
    const clientHubUuId = await this.getParam('clientHubUuId');
    const redirectPath = await this.getParam('successRoute');
    const sucessPath = clientHubUuId ? 'success-no-auth' : 'success';
    if (clientHubUuId) {
      const params = {
        header: 'Invoice Paid',
        body: '',
        buttonText: 'Ok',
        buttonRoute: redirectPath
      };
      this.rightSidePanelService.navigateTo(sucessPath, params, SuccessPage);
    } else {
      this.storage.save('didMakeBillChanges', true);
      this.storage.save('paidInvoiceId', this.invoice.id);
      this.util.showSuccess('Invoice Paid');
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.navigateRoot('bills');
      }
    }
  }

  getCardTitle() {
    if (this.hasAccount) {
      if (this.lastFourCC) {
        if (this.form.value.howToPay === 'currentCard') {
          return 'Log In to Use Card';
        } else {
          return 'Log In to Save Card';
        }
      } else {
        return 'Log In to Add Card';
      }
    } else {
      return 'Create Account to Save Card';
    }
  }

  updateHowToPay(selection) {
    this.showACHDebitMessage = false;
    this.form.patchValue({
      otherOptions: null
    });
    if (selection.value === 'alreadyPaid') {
      this.unselectAllCredits();
      this.form.controls.otherOptions.setValidators(Validators.required);
      this.form.controls.otherOptions.updateValueAndValidity();
    } else {
      this.form.controls.otherOptions.clearValidators();
      this.form.controls.otherOptions.updateValueAndValidity();
    }
    if (this.form.value.howToPay === 'currentCard') {
      this.selectPossibleCreditsToUse();
      this.getPaymentPreview();
    }
  }

  unselectAllCredits() {
    this.selectedCredits.forEach(credit => {
      this.form.removeControl(credit.title);
      // Uncheck the checkbox form control
      const checkboxControlName = `${credit.title}_checkbox`;
      if (this.form.contains(checkboxControlName)) {
        this.form.patchValue({ [checkboxControlName]: false });
      }
    });
    this.selectedCredits = [];
    this.checkHowMuchCreditIsUsed();
    this.updateHowToPayLabel();
  }

  getSelectedOtherOption(selection) {
    if (selection === 'achDebit') {
      return this.showACHDebitMessage = true;
    }
    this.showACHDebitMessage = false;
    this.paymentOptions.map((option) => {
      if (option.team_payment_option_type.id === selection) {
        this.selectedOtherOption = option;
      }
    });
  }

  copyToClipBoard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    this.copied = true;
    setTimeout(() => this.copied = false, 3000);
  }

  getMessageSelectItems() {
    return [
      {
        value: 'is_internal',
        viewValue: new TranslationPipe().transform('Internal note'),
        icon: 'assets/svg/create-outline.svg'
      },
      {
        value: 'public_reply',
        viewValue: new TranslationPipe().transform('Public note'),
        icon: 'assets/svg/arrow-redo-outline.svg'
      }
    ]
  }

  updateIsInternalComment(selection) {
    this.isInternalComment = selection === 'is_internal';
    this.selectedMessageType = this.isInternalComment ? this.messageSelectItems[0] : this.messageSelectItems[1];
  }

  @Loading('', true)
  async sendMessage() {
    this.errorMessage = '';
    try {
      const payload = {
        invoice_id: this.invoice.id,
        type: 'text',
        is_internal: this.isInternalComment,
        text: this.form.value.message
      }
      await this.createInvoiceNote(payload);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  async sendAttachment() {
    this.errorMessage = '';
    try {
      const attachment = await this.invoices.addAttachment();
      if (!attachment.url) {
        return this.errorMessage = 'Unable to attach file. Please upload a PNG, JPEG, PDF, or Word document.';
      }
      const payload = {
        invoice_id: this.invoice.id,
        type: attachment.type,
        is_internal: this.isInternalComment,
        media_url: attachment.url
      }
      await this.createInvoiceNote(payload);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  async createInvoiceNote(payload) {
    await this.invoices.createInvoiceNote(payload);
    this.form.patchValue({
      message: ''
    });
    this.invoiceNotes = await this.invoices.getInvoiceNotes(this.invoice.id);
  }

  toggleShowAllInvoiceNotes() {
    this.showAllInvoiceNotes = true;
  }

  async copyBillLink() {
    const link = `pending-bill/${this.invoice.id}`
    this.invoices.copyBillLink(link);
    this.util.showSuccess('Bill link copied')
  }

  goToLoadCredit() {
    this.rightSidePanelService.navigateTo('payment-methods/load-credit', {});
  }

  checkHowMuchCreditIsUsed() {
    this.showNotEnoughCreditWarning = false;
    this.getAmountCreditUsed();
    if (this.amountCreditUsed > this.totalOwed) {
      this.showTooMuchCreditSelectedWarning = true;
      this.form.controls.howToPay.clearValidators();
      this.form.controls.howToPay.updateValueAndValidity();
    } else {
      this.showTooMuchCreditSelectedWarning = false;
      this.showPaymentMethodOptions = true;
      this.form.controls.howToPay.setValidators(Validators.required);
      this.form.controls.howToPay.updateValueAndValidity();
    }
    this.updateHowToPayLabel();
  }

  getAmountCreditUsed() {
    this.amountCreditUsed = 0;
    this.selectedCredits.forEach((credit) => {
      let amount = this.form.value[credit.title];
      if (amount.includes('$')) {
        amount = amount.replace('$', '');
        amount = amount.replace(',', '');
      }
      amount = Math.round(parseFloat(amount) * 100);
      if (isNaN(amount)) {
        amount = 0;
      }
      if (amount > credit.available_amount) {
        this.showNotEnoughCreditWarning = true;
      }
      this.amountCreditUsed += amount;
    });
  }

  updateHowToPayLabel() {
    const amountCreditDoesntCover = this.totalOwed - this.amountCreditUsed;
    if (amountCreditDoesntCover > 0) {
      if (this.amountCreditUsed === 0) {
        this.howToPayLabel = `${new TranslationPipe().transform('How do you want to pay the ')} ${new TidyCurrencyPipe().transform(amountCreditDoesntCover)} ${new TranslationPipe().transform('balance?')}`;
      } else {
        this.howToPayLabel = `${new TranslationPipe().transform('How do you want to pay the remaining')} ${new TidyCurrencyPipe().transform(amountCreditDoesntCover)} ${new TranslationPipe().transform('balance?')}`;
      }
    } else {
      this.howToPayLabel = `${new TranslationPipe().transform('How do you want to pay the ')} ${new TidyCurrencyPipe().transform(amountCreditDoesntCover)} ${new TranslationPipe().transform('balance?')}`;
      this.showPaymentMethodOptions = false;
    }
  }

  async getPaymentPreview() {
    this.paymentPreview = null;
    const payload = this.getInvoicePayload();
    this.paymentPreview = await this.invoices.getPaymentPreview(this.invoice.id, payload);
  }

  getInvoicePayload() {
    const payload: any = {
      invoice_id: this.invoice.id,
      credits_to_use: [],
      additional_data: {},
    }
    const paymentMethod = this.getPaymentMethodPayload();
    if (paymentMethod) {
      payload['payment_method'] = paymentMethod;
    }
    this.selectedCredits.forEach((credit) => {
      let amount = this.form.value[credit.title];
      if (amount.includes('$')) {
        amount = amount.replace('$', '');
        amount = amount.replace(',', '');
      }
      amount = Math.round(parseFloat(amount) * 100);
      if (!isNaN(amount)) {
        payload.credits_to_use.push({ from_type: credit.from_type, amount_to_use: amount });
      }
    });
    return payload;
  }

  getPaymentMethodPayload() {
    if (!this.showPaymentMethodOptions) {
      return null;
    }
    const payload = {
      type: 'default_payment_method'
    };
    if (this.form.value.howToPay === 'newCard' && this.newCard) {
      payload['id'] = this.newCard.id;
      payload['type'] = 'payment_method';
    }
    if (typeof this.form.value.howToPay === 'string' && this.form.value.howToPay.startsWith('check_')) {
      payload['id'] = parseInt(this.form.value.howToPay.replace('check_', ''), 10);
      payload['type'] = 'payment_method';
    }
    return payload;
  }


  getFromTitle(fromType) {
    const type = this.selectedCredits.find((credit) => credit.from_type === fromType);
    if (type) {
      return type.title;
    } else {
      return new TranslationPipe().transform('Credit Card');
    }
  }

  // An arrow function: tidy-button calls its action with itself as `this`
  addNewCard = async () => {
    try {
      this.captchaErrorMessage = false;
      if (this.hasValidCaptcha === null) {
        return this.captchaErrorMessage = true;
      }
      const cardData: any = await this.getStripeCardData();
      this.newCard = await this.card.saveCard(cardData);
      this.util.showSuccess('Card saved and added as primary payment method.');
      this.lastFourCC = await this.getLastFourCC();
      this.howToPayItems = await this.getHowToPayItems();
      this.patchHowToPayItem();
      await this.getPaymentPreview();
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  };

  async getStripeCardData() {
    const stripeData = await this.stripeProvider.getInstance().createToken(this.cardEl);
    if (stripeData?.error) {
      throw stripeData.error;
    }
    return {
      type: 'card',
      stripe_card_token: stripeData.token.id,
      primary_payment_method: true,
    };
  }

}
